import { render, staticRenderFns } from "./CandidateStaticContents.vue?vue&type=template&id=16b3da1b&"
import script from "./CandidateStaticContents.vue?vue&type=script&lang=js&"
export * from "./CandidateStaticContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports